<template>
  <div class="authorCenter">
    <Header></Header>
    <div class="authorBox flexible authorBox-big">
      <sidebar></sidebar>
      <div class="writewrap flex">
        <Bread></Bread>
        <div class="totalBox font-MT text-fff flexible aItem-center" v-if="paylogdata">
          <div class="title">
            <img src="../../assets/income/icon1.png"/>
           {{$lang('authorCenter.income.Totalincome')}}
          </div>
          <div class="count flexible">
            <img src="../../assets/income/icon2.png"/>
            <span>{{paylogdata.allIncome  }}</span>
          </div>
          <div v-if="paylogdata.inspectStatus && paylogdata.inspectStatus.value!=-10">
            <el-button class="f16 font-MT" @click="applywithdrawal()" v-if="paylogdata.inspectStatus.value == 0">{{$lang('authorCenter.income.withdrawalBtn[0]')}}</el-button>
            <el-button class="f16 font-MT el-button-opa" v-if="paylogdata.inspectStatus.value == 1 ||paylogdata.inspectStatus.value == 2||paylogdata.inspectStatus.value == 3">{{$lang('authorCenter.income.withdrawalBtn[1]')}}</el-button>
            <el-button class="f16 font-MT" type="success" v-if="paylogdata.inspectStatus.value == 4">{{$lang('authorCenter.income.withdrawalBtn[2]')}}</el-button>
          </div>
          <el-popover
                  placement="bottom"
                  title=""
                  popper-class="ic_rule"
                  width="538"
                  trigger="hover">
            <div v-html="$lang('authorCenter.income.rules')"></div>
            <img class="ic_rule_img" slot="reference" src="../../assets/income/ic_rules.png"/>
          </el-popover>
        </div>
        <div class="right mt20" v-loading="loading" style="overflow: auto">
          <el-form :inline="true" class="income-form">
            <el-form-item>
              <el-select v-model="queryParams.bookId">
                <el-option style="width: 500px" v-for="i in bookList" :value="i.id" :label="i.iname"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                      v-model="time"
                      type="daterange"
                      range-separator="-"
                      value-format="yyyy-MM-dd"
                      start-placeholder="beginDate"
                      end-placeholder="endDate">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button class="ml24" icon="el-icon-search"  @click="getauthorCashlist()">{{$lang('authorCenter.income.Search')}}</el-button>
            </el-form-item>
          </el-form>
          <incomeEcharts  v-if="paylogdata&&paylogdata.x_data.length >= 2" :chartData="paylogdata"></incomeEcharts>
          <el-table
                  v-if="authorCashList&&authorCashList.length > 0"
                  class="income-table"
            :data="authorCashList"
            stripe
          >
            <el-table-column align="center" prop="day" :label="$lang('authorCenter.income.withdrawalTable[0]')"></el-table-column>
            <el-table-column align="center" prop="date" :label="$lang('authorCenter.income.withdrawalTable[1]')">
              <template slot-scope="scope">
                <span>{{scope.row.applyType.desc}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="money" :label="$lang('authorCenter.income.title')"></el-table-column>
          </el-table>
          <div class="datanull" v-if="authorCashList&&authorCashList.length == 0">
            <img src="@/assets/author/no-data.png"/>
            <p>{{$lang('authorCenter.income.NoIncome')}}</p>
          </div>
          <pagination
                  class="fr"
                  v-show="total>0"
                  :total="total"
                  :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getauthorCashlist()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import incomeEcharts from "./incomeEcharts";
  import {authorpayloglist, AuthorBookList, authorapply} from '@/api/author'
  import Pagination from "@/components/Pagination/index"
  import {formatDate} from '@/utils/index'
  export default {
    data() {
      return {
        chartData: {},
        authorCashList: [],
        bookList: [],
        total: 0,
        queryParams: {
          pageNo: 1,
          pageSize: 50,
          beginDate: '',
          endDate: '',
          bookId: ''
        },
        time: '',
        paylogdata: null,
        loading: false
      }
    },
    created() {
    },
    mounted() {
      this.getAuthorBookList()
    },
    components: {incomeEcharts, Pagination},
    methods: {
      // 获取作品信息
      getAuthorBookList () {
        AuthorBookList({pageNo: 1, pageSize: 1000}).then(res=>{
          if (res.data.length == 0) {
            this.bookList = []
          } else {
            this.bookList = res.data.items
          }
          if (this.bookList.length == 0) {
            this.authorCashList = []
          } else {
            this.queryParams.bookId = res.data.items[0].id
            this.time = [formatDate(new Date(), 'before', 7), formatDate(new Date(), 'date')]
            this.getauthorCashlist()
          }
        })
      },
      // 数据查询
      getauthorCashlist () {
        if (!this.time) {
          this.$faild('custom', 'Please select the time range！！！')
          return false
        }
        this.queryParams.beginDate = this.time[0]
        this.queryParams.endDate = this.time[1]
        this.loading = true
        authorpayloglist(this.queryParams).then(res=>{
          console.log(res)
          this.loading = false
          this.paylogdata = res.data
          this.authorCashList = res.data.details.records
          this.total = Number(res.data.details.total)
          this.$nextTick(() => {
            if (this.paylogdata.x_data.length >= 2) {
              this.$refs.echarts.drawChart()
            }
          })
        })
      },
      // 申请提现
      applywithdrawal () {
        authorapply({}).then(res=> {
          console.log(res)
          if (res.data) {
            this.$success('custom', 'Successed!')
            this.paylogdata.inspectStatus.value = 1
          }
        })
      }
    }
};
</script>
<style>
  .ic_rule{
    width: 538px;
    box-shadow: 0px 2px 14px 0px rgba(0,0,0,0.1000) !important;
    border-radius: 16px!important;
    font-size: 18px;
    line-height: 32px;
    color: #333;
    padding: 20px 50px 30px 30px;
  }
</style>
<style lang="scss" scoped>
  @import "@/styles/author.scss";
  .totalBox{
    margin-left: 24px;
    background: #272736;
    height: 140px;
    border-radius: 16px;
    .title{
      margin-left: 50px;
      font-size: 30px;
      img{
        width: 17px;
        height: 17px;
      }
    }
    .count{
      margin-left: 40px;
      font-size: 34px;
      font-weight: bold;
      img{
        height:57px;
        width: 35px;
        margin-right: 20px;
        margin-top: -10px;
      }
    }
    .ic_rule_img{
      width: 44px;
      height: 44px;
      margin-left: 10px;
    }
    /deep/.el-button{
      /*width: 181px!important;*/
      padding: 0 10px!important;
      height: 40px;
      margin-left: 30px;
    }
  }
  .income-form{
    /deep/.el-input__inner,/deep/.el-range-input{
      background: #28283D;
      border-color: #575776;
      color: #fff;
    }
    /deep/.el-date-editor .el-range-separator{
      color: #979797!important;
    }
    .cross-line{
      color: #979797;
    }
  }
  .income-table{
    border: 1px solid #575776;
    border-right: none;
    margin-top: 50px;
    &.el-table--border::after, &.el-table--group::after, &.el-table::before{
      background: none;
    }
    /deep/th{
      background: linear-gradient( 180deg, #8D59F7 0%, #5B57FF 100%, #5A57FF 100%);
      color: #fff!important;
    }
    /deep/th,
    /deep/td{
      font-size: 16px!important;
      font-family: Arial!important;
      border-right: 1px solid #575776!important;
      border-bottom: 1px solid #575776!important;
    }
    /deep/td{
      color: #fff!important;
      background: #272736!important;
    }
    /deep/ tr.el-table__row--striped td.el-table__cell{
      background: #3A3A51!important;
    }
   /deep/ tr:hover > td {
     background-color: #272736!important;
   }

  }
  /deep/.el-pager li.active{
    background: #7DB36C!important;
  }
</style>
